<template>
  <a-modal
    centered
    width="calc(100vw - 80px)"
    height="calc(100vh - 80px)"
    :visible="true"
    :closable="false"
    :mask-closable="false"
    :footer="null"
  >
    <template slot="title">
      <div class="header-wrap">
        <p class="title-content">
          <a-tooltip v-if="itvCourseName.length > 15" placement="top">
            <template slot="title">
              <span>{{ itvCourseName }}</span>
            </template>
            <span>{{ itvCourseName }}</span>
          </a-tooltip>
          <span v-else>
            {{ itvCourseName }}
          </span>
          <span>课程ID：{{ classTypeId }}</span>
        </p>
        <i class="icon-close iconfont delete" @click="handleCancel" />
      </div>
    </template>
    <template v-if="record.sourceType === 2">
      <!-- coursePackageId: 2975 -->
      <InJzxTool
        page-type="2"
        :page-params="{
          coursePackageId: record.classTypeId,
          sourceType: 4,
          isEdit: false
        }"
      />
    </template>
    <template v-else>
      <div class="resource-wrap">
        <ul class="res-tab">
          <li
            class="tab-btn"
            v-for="item in tabList"
            :key="item.key"
            :class="{'tab-cur': item.key === curTab.key}"
            @click="changeTab(item)"
            v-html="item.name"
          />
        </ul>
        <div v-if="lessonList && lessonList.length" class="lesson-wrap xkh-custom-scrollbar" v-show="isLessonShow">
          <ul class="lesson-list">
            <li
              v-for="item in lessonList"
              :key="item.id"
              :class="item.id === curLesson.id ? 'cur-lesson' : ''"
              @click="lessonChange(item)"
            >
              <p>第{{ item.num }}讲<span class="lesson-tag" v-if="item.tagName">{{ item.tagName }}</span></p>
              <a-tooltip v-if="item.name.length > 17" placement="top">
                <template slot="title">
                  <p>{{ item.name }}</p>
                </template>
                <p>{{ item.name }}</p>
              </a-tooltip>
              <p v-else>
                {{ item.name }}
              </p>
            </li>
          </ul>
        </div>
        <div class="res-content" :class="{'xkh-custom-scrollbar': curTab.key !== 'kejian'}">
          <div v-if="isEmpty" class="xkh-empty-wrap">
            <img src="@/static/images/null/null-2.png" />
            <p>暂无内容</p>
          </div>
          <component
            v-else-if="curTab.component && isContentShow"
            :is="curTab.component"
            :class-type-id="classTypeId"
            :lesson-id="curLesson.id"
          />
        </div>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { defineComponent, ref, computed } from 'vue-demi'
import SupMaterial from '@/views/courseAndCorrect/prepareLesson/supMaterial/index.vue'
import CourseWare from '@/views/courseAndCorrect/prepareLesson/courseWare/index.vue'
import CourseSubRes from './CourseSubRes.vue'
import AiCourse from './AiCourse.vue'
import service from '@/service/index'
import Analysis from '../../courseAndCorrect/prepareLesson/analysis/index.vue'
import InJzxTool from '@/components/InJzxTool/index.vue'
export default defineComponent({
  name: 'CourseResource',
  components: { SupMaterial, CourseWare, AiCourse, CourseSubRes, Analysis, InJzxTool },
  props: {
    record: Object
  },

  // mixins: [mixins],
  setup(props, { root, refs, emit }) {
    const lessonId = ref(null)
    // 当前选中的 tab
    const curTab = ref({})
    // 当前选中的讲次
    const curLesson = ref({})
    const isContentShow = ref(true)
    const tabList = [
      {
        name: 'AI课程',
        key: 'ai',
        component: AiCourse
      },
      {
        name: '课件',
        key: 'kejian',
        component: CourseWare
      },
      {
        name: '课程</br>补充资料',
        key: 'courseSubRes',
        component: CourseSubRes
      },
      {
        name: '讲次</br>补充资料',
        key: 'lessonSubRes',
        component: SupMaterial
      },
      {
        name: '题目解析',
        key: 'analysis',
        component: Analysis
      }
    ]
    // 班型id
    const classTypeId = computed(() => props.record.classTypeId)
    // 学习机课程名称
    const itvCourseName = computed(() => props.record.itvCourseName)
    // 讲次列表
    const lessonList = ref(null)

    // 是否显示讲次
    const isLessonShow = computed(() => curTab.value.key !== 'courseSubRes')

    // 课程讲次为空
    const isEmpty = computed(() => isLessonShow.value && lessonList.value && !lessonList.value.length)

    const initData = async () => {
      // 获取讲次信息
      const res = await service.common.lessonList({
        classTypeId: classTypeId.value
      })
      lessonList.value = res.map(item => {
        let tagName = ''
        const { tag } = item
        if (tag === 1) {
          tagName = '期中'
        }
        if (tag === 2) {
          tagName = '期末'
        }
        return {
          ...item,
          tagName
        }
      })
      if (!res.length) {
        return
      }
      curLesson.value = lessonList.value[0]
      lessonId.value = lessonList.value[0].id
    }
    const handleCancel = () => {
      emit('close')
    }
    const changeTab = item => {
      curTab.value = item
    }
    const lessonChange = item => {
      curLesson.value = item
      isContentShow.value = false
      root.$nextTick(() => {
        isContentShow.value = true
      })
    }
    // 初始化数据
    initData().then(() => {
      root.$nextTick(() => {
        curTab.value = tabList[0]
      })
    })
    return {
      handleCancel,
      classTypeId,
      lessonId,
      lessonList,
      tabList,
      curTab,
      curLesson,
      isContentShow,
      changeTab,
      lessonChange,
      isLessonShow,
      isEmpty,
      itvCourseName
    }
  }
})
</script>
<style lang="less" scoped>
:deep(.ant-modal-content) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
:deep(.ant-modal-body) {
  flex: 1;
  padding: 0;
}
:deep(.ant-modal-header) {
  padding: 0 24px !important;
  height: 54px;
  display: flex;
  align-items: center;
}
:deep(.ant-modal-title) {
  width: 100%;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .icon-close {
    font-size: 24px;
    color: #98A2B2
  }
}
.title-content {
  display: flex;
  align-items: center;
  span {
    padding-right: 16px;
    position: relative;
    color: #70788C;
    font-weight: 400;
    font-size: 14px;
    &:first-child {
      max-width: 268px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #505873;
      font-weight: 700;
      font-size: 16px;
    }
    &::after {
      position: absolute;
      content: '';
      width: 1px;
      height: 16px;
      background: #EBEDF0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &:last-child {
      padding-left: 16px;
      &::after {
        width: 0;
      }
    }
  }
}
.resource-wrap {
  display: flex;
  height: 100%;
  ul {
    margin-bottom: 0;
  }
}
.res-tab {
  padding: 20px;
  border-right: 1px solid #EBEDF0;
  margin-bottom: 0;
}
.tab-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 91px;
  line-height: 20px;
  padding: 8px 0;
  box-sizing: border-box;
  border: 2px solid #DFE2E6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  color: #70788C;
  margin-bottom: 12px;
  cursor: pointer;
  &.tab-cur {
    border: none;
    background: #3262FD;
    color: #fff;
  }
}
.lesson-wrap {
  width: 226px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 20px;
  border-right: 1px solid #EBEDF0;
}
.lesson-list {
  line-height: 22px;
  li {
    box-sizing: border-box;
    margin-bottom: 12px;
    padding: 8px 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    &::after {
      position: absolute;
      content: '';
      pointer-events: none;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border: 1px solid #DFE2E6;
      border-radius: 8px;
    }
    p {
      color: #505873;
      &:first-child {
        display: flex;
        align-items: center;
        .lesson-tag {
          display: inline-block;
          margin-left: 8px;
          background: rgba(6, 194, 112, 0.2);
          border-radius: 4px;
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          padding: 2px 6px;
          color: #06C270;
        }
      }
      &:last-child {
       word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
        color: #70788C;
        margin-bottom: 0;
      }
    }
    &:hover {
      background: #F5F9FF
    }
    &.cur-lesson {
      &::after {
        border-color: #2357FF;
        border-width: 2px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.res-content {
  flex: 1;
}
</style>